import { gql } from '@edreamsodigeo/frontend-api-client';

export const createPriceFreeze = gql`
  mutation createPriceFreeze($request: CreatePriceFreezeRequest!) @silent {
    itineraryPriceFreeze(request: $request)
  }
`;

export const getItineraryPriceFreeze = gql`
  query getItineraryPF($id: ID!) {
    itineraryPriceFreeze(id: $id) {
      id
      bookingId
      feeContainerId
      status
      itineraryPriceFreezeItinerary {
        primePrice {
          amount
          currency
        }
        nonPrimePrice {
          amount
          currency
        }
        primeAndNonPrimePricesDifference {
          amount
          currency
        }
        type
        numAdults
        segments {
          sections {
            departureDate
            arrivalDate
            departureLocation {
              cityName
              iata
            }
            destinationLocation {
              cityName
              iata
            }
          }
        }
      }
      condition {
        expirationDate
        frozenPrice {
          amount
          currency
        }
        deposit {
          amount
          currency
        }
        cap {
          amount
          currency
        }
        redemptionPolicy {
          primeMembershipRequired
        }
        primeMembershipActivationPolicy {
          primeMembershipActivationRequiredIfNotPrimeMember
        }
      }
      itineraryPriceFreezeRedemptionId {
        itineraryPriceFreezeRedemptionType
      }
    }
  }
`;
